import React from "react";

const GooglePlay = ({ size = "18" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Google play'>
        <g id='Icon'>
          <path
            id='Vector'
            d='M2.73265 1.90313C2.58528 2.05354 2.5 2.28771 2.5 2.59097V13.4081C2.5 13.7113 2.58528 13.9455 2.73265 14.0959L2.76902 14.1289L8.98597 8.06982V7.92675L2.76902 1.86767L2.73265 1.90313Z'
            fill='#212121'
          />
          <path
            id='Vector_2'
            d='M11.8083 10.0898L9.73828 8.06913V7.92606L11.8108 5.90535L11.8572 5.93164L14.3116 7.29325C15.0121 7.67966 15.0121 8.31553 14.3116 8.70439L11.8572 10.0636L11.8083 10.0898V10.0898Z'
            fill='#212121'
          />
          <path
            id='Vector_3'
            d='M11.4814 10.4405L9.36245 8.37456L3.10913 14.4722C3.34178 14.7106 3.72117 14.7393 4.15261 14.5009L11.4814 10.4405'
            fill='#212121'
          />
          <path
            id='Vector_4'
            d='M11.4814 5.55514L4.15261 1.49476C3.72117 1.25875 3.34178 1.28749 3.10913 1.52594L9.36245 7.62109L11.4814 5.55514Z'
            fill='#212121'
          />
        </g>
      </g>
    </svg>
  );
};

export default GooglePlay;
